<template>
  <div>
    <div class="flex-container">
      <div class="tab_menu">
        <div class="menu_items">
          <div class="menu_item" :class="
            form_step.slug == form_steps.step_information.slug
              ? 'is_active'
              : ''
          " @click="setupFormLevel(form_steps.step_information)">
            <!-- <feather-icon icon="MenuIcon" svgClasses="w-5 h-5 stroke-current" /> -->
            <svg v-if="form_step.slug == form_steps.step_information.slug" width="18" height="19" viewBox="0 0 18 19"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11 14.8481H4V12.8481H11V14.8481ZM14 10.8481H4V8.84814H14V10.8481ZM14 6.84814H4V4.84814H14V6.84814ZM16 0.848145H2C0.89 0.848145 0 1.73814 0 2.84814V16.8481C0 17.3786 0.210714 17.8873 0.585786 18.2624C0.960859 18.6374 1.46957 18.8481 2 18.8481H16C16.5304 18.8481 17.0391 18.6374 17.4142 18.2624C17.7893 17.8873 18 17.3786 18 16.8481V2.84814C18 2.31771 17.7893 1.809 17.4142 1.43393C17.0391 1.05886 16.5304 0.848145 16 0.848145Z"
                fill="#FFCC00" />
            </svg>
            <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6ZM16 0H2C0.89 0 0 0.89 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0Z"
                fill="black" />
            </svg>

            Informations
          </div>
          <div class="menu_item" :class="
            form_step.slug == form_steps.step_training.slug ? 'is_active' : ''
          " @click="setupFormLevel(form_steps.step_training)">
            <!-- <feather-icon icon="MenuIcon" svgClasses="w-5 h-5 stroke-current" /> -->
            <svg v-if="form_step.slug == form_steps.step_training.slug" width="16" height="21" viewBox="0 0 16 21"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 20.8481C14.5304 20.8481 15.0391 20.6374 15.4142 20.2624C15.7893 19.8873 16 19.3786 16 18.8481V2.84814C16 2.31771 15.7893 1.809 15.4142 1.43393C15.0391 1.05886 14.5304 0.848145 14 0.848145H8V7.84814L5.5 6.34814L3 7.84814V0.848145H2C1.46957 0.848145 0.960859 1.05886 0.585786 1.43393C0.210714 1.809 0 2.31771 0 2.84814V18.8481C0 19.3786 0.210714 19.8873 0.585786 20.2624C0.960859 20.6374 1.46957 20.8481 2 20.8481H14Z"
                fill="#FFCC00" />
            </svg>
            <svg v-else width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 20.8481C14.5304 20.8481 15.0391 20.6374 15.4142 20.2624C15.7893 19.8873 16 19.3786 16 18.8481V2.84814C16 2.31771 15.7893 1.809 15.4142 1.43393C15.0391 1.05886 14.5304 0.848145 14 0.848145H8V7.84814L5.5 6.34814L3 7.84814V0.848145H2C1.46957 0.848145 0.960859 1.05886 0.585786 1.43393C0.210714 1.809 0 2.31771 0 2.84814V18.8481C0 19.3786 0.210714 19.8873 0.585786 20.2624C0.960859 20.6374 1.46957 20.8481 2 20.8481H14Z"
                fill="black" />
            </svg>

            Formations
          </div>
          <div class="menu_item" :class="
            form_step.slug == form_steps.step_quizz.slug ? 'is_active' : ''
          " @click="setupFormLevel(form_steps.step_quizz)">
            <!-- <feather-icon icon="MenuIcon" svgClasses="w-5 h-5 stroke-current" /> -->
            <svg v-if="form_step.slug == form_steps.step_quizz.slug" width="21" height="22" viewBox="0 0 21 22"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.5 10.8481H17V6.84814C17 6.31771 16.7893 5.809 16.4142 5.43393C16.0391 5.05886 15.5304 4.84814 15 4.84814H11V3.34814C11 2.6851 10.7366 2.04922 10.2678 1.58038C9.79893 1.11154 9.16304 0.848145 8.5 0.848145C7.83696 0.848145 7.20107 1.11154 6.73223 1.58038C6.26339 2.04922 6 2.6851 6 3.34814V4.84814H2C1.46957 4.84814 0.960859 5.05886 0.585786 5.43393C0.210714 5.809 0 6.31771 0 6.84814V10.6481H1.5C3 10.6481 4.2 11.8481 4.2 13.3481C4.2 14.8481 3 16.0481 1.5 16.0481H0V19.8481C0 20.3786 0.210714 20.8873 0.585786 21.2624C0.960859 21.6374 1.46957 21.8481 2 21.8481H5.8V20.3481C5.8 18.8481 7 17.6481 8.5 17.6481C10 17.6481 11.2 18.8481 11.2 20.3481V21.8481H15C15.5304 21.8481 16.0391 21.6374 16.4142 21.2624C16.7893 20.8873 17 20.3786 17 19.8481V15.8481H18.5C19.163 15.8481 19.7989 15.5848 20.2678 15.1159C20.7366 14.6471 21 14.0112 21 13.3481C21 12.6851 20.7366 12.0492 20.2678 11.5804C19.7989 11.1115 19.163 10.8481 18.5 10.8481Z"
                fill="#FFCC00" />
            </svg>
            <svg v-else width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.5 10.8481H17V6.84814C17 6.31771 16.7893 5.809 16.4142 5.43393C16.0391 5.05886 15.5304 4.84814 15 4.84814H11V3.34814C11 2.6851 10.7366 2.04922 10.2678 1.58038C9.79893 1.11154 9.16304 0.848145 8.5 0.848145C7.83696 0.848145 7.20107 1.11154 6.73223 1.58038C6.26339 2.04922 6 2.6851 6 3.34814V4.84814H2C1.46957 4.84814 0.960859 5.05886 0.585786 5.43393C0.210714 5.809 0 6.31771 0 6.84814V10.6481H1.5C3 10.6481 4.2 11.8481 4.2 13.3481C4.2 14.8481 3 16.0481 1.5 16.0481H0V19.8481C0 20.3786 0.210714 20.8873 0.585786 21.2624C0.960859 21.6374 1.46957 21.8481 2 21.8481H5.8V20.3481C5.8 18.8481 7 17.6481 8.5 17.6481C10 17.6481 11.2 18.8481 11.2 20.3481V21.8481H15C15.5304 21.8481 16.0391 21.6374 16.4142 21.2624C16.7893 20.8873 17 20.3786 17 19.8481V15.8481H18.5C19.163 15.8481 19.7989 15.5848 20.2678 15.1159C20.7366 14.6471 21 14.0112 21 13.3481C21 12.6851 20.7366 12.0492 20.2678 11.5804C19.7989 11.1115 19.163 10.8481 18.5 10.8481Z"
                fill="black" />
            </svg>

            Evaluations
          </div>
        </div>
      </div>
      <div class="tab_content">
        <vs-card fixedHeight>
          <div slot="header">
            <h5 class="font-bold">{{ form_step.title }}</h5>
          </div>
          <!-- content -->
          <add-pack-information v-if="this.form.information.title" :isPromptActive="
            form_step.slug == form_steps.step_information.slug ? true : false
          " :isFormEmpty="empty_form ? true : false" :callBackInformation="callBackInformation"
            :information="form.information" />
          <add-pack-training v-if="form.trainings.length > 0" :isPromptActive="
            form_step.slug == form_steps.step_training.slug ? true : false
          " :isFormEmpty="empty_form ? true : false" :callBackTraining="callBackTrainings"
            :formations="form.trainings" />
          <add-pack-multi-quizz v-if="form.quizzs.length > 0" :isPromptActive="
            form_step.slug == form_steps.step_quizz.slug &&
              form.information.type_evaluation_id == 'une-par-formation'
              ? true
              : false
          " :isFormEmpty="empty_form ? true : false" :callBackQuizz="callBackQuizz" :trainings="form.trainings"
            :evaluations="form.quizzs" />
          <add-pack-quizz @importQuestionEvent="importQuestionEvent" v-if="form.quizzs.length > 0" :isPromptActive="
            form_step.slug == form_steps.step_quizz.slug &&
              form.information.type_evaluation_id == 'unique'
              ? true
              : false
          " :isFormEmpty="empty_form ? true : false" :callBackQuizz="callBackQuizz" :evaluation="form.quizzs[0]"
            :trainings="form.trainings" />
          <!-- end content -->
          <div class="footer mt-12 pb-6">
            <vs-row vs-justify="flex-end" class="footer-row">
              <vs-button class="black-button" @click="$router.go(-1)">Annuler</vs-button>
              <vs-button v-if="form_step.slug > 1" class="ml-2 black-button"
                @click="goToPreviousLevel">Précédent</vs-button>
              <vs-button v-if="form_step.slug !== 3" class="ml-2 text-dark action-button"
                @click="goToNextLevel">Suivant</vs-button>
              <vs-button v-if="FormValid && form_step.slug == 3" class="ml-2 text-dark black-button"
                @click="saveTrainingPack">Sauvegarder</vs-button>
              <vs-button v-if="FormValid && form_step.slug == 3 && published !== 1" class="ml-2 text-dark action-button"
                @click="publishTrainingPack">Publier</vs-button>
            </vs-row>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import AddPackInformation from "./add-packInformation.vue";
import AddPackTraining from "./add-packTraining.vue";
import AddPackQuizz from "./add-packQuizz.vue";
import AddPackMultiQuizz from "./add-packMultiQuizz.vue";

export default {
  name: "update-pack",
  components: {
    AddPackInformation,
    AddPackTraining,
    AddPackQuizz,
    AddPackMultiQuizz,
  },
  data() {
    return {
      form_steps: {
        step_information: {
          slug: 1,
          title: "Informations du pack de formation",
        },
        step_training: {
          slug: 2,
          title: "Ajouter / Joindre des formations",
        },
        step_quizz: {
          slug: 3,
          title: "Création de l’évaluation",
        },
      },
      form_step: {
        slug: 1,
        title: "Informations du pack de formation",
      },
      empty_form: false,
      form: {
        information: {
          title: "",
          teams: [],
          type_evaluation_id: "",
          seniority_required: 30,
          illustration: "",
        },
        trainings: [],
        quizzs: [],
      },
      trainings: [],
      pack_backend_id: "",
      published: "0",
      FormValid: false
    };
  },
  computed: {},
  watch: {
    "form.information.type_evaluation_id": function (value) {
      if (value == "une-par-formation") {
        this.form_steps.step_quizz.title = "Création des évaluations";
      } else {
        this.form_steps.step_quizz.title = "Creation de l’évaluation";
      }
    },
    form: {
      handler: function () {
        this.checkForm();
      },
      deep: true,
    },
  },
  methods: {
    importQuestionEvent(questions) {
      if (this.form.quizzs.length > 0) {
        this.form.quizzs[0].questions = questions;
      } else this.form.quizzs[0] = { questions: questions };

      this.checkForm();
    },
    checkForm() {
      // console.log(2);
      let check_quizz = this.checkQuizzDetails();
      if (
        this.form.information.title !== "" &&
        this.form.information.teams.length > 0 &&
        this.form.information.type_evaluation_id !== "" &&
        this.form.information.seniority_required !== "" &&
        this.form.information.illustration !== "" &&
        this.form.trainings.length > 0 &&
        check_quizz
      ) {
        this.FormValid = true;
      } else this.FormValid = false;
    },
    checkQuizzDetails() {
      let is_ok = true;
      if (this.form.quizzs.length > 0) {
        this.form.quizzs.forEach((element) => {
          if (element.title == "") is_ok = false;
          if (element.required_avg == "") is_ok = false;
          if (element.nbr_question_by_survey == "") is_ok = false;
          if (element.duration == "") is_ok = false;
          if (element.category) {
            if (element.category.id == "" || element.category.id == null) is_ok = false;
          } else if (element.category_id == "" || element.category_id == null) is_ok = false;
          // console.log(element, "33");
          if (element.questions.length > 0) {
            element.questions.forEach((question) => {
              if (question.type_question == "") is_ok = false;
              if (question.question == "") is_ok = false;
              if (question.instructions == "") is_ok = false;
              if (Array.isArray(question.answers)) {
                question.answers.forEach((answer) => {
                  if (answer.answers == "") is_ok = false;
                });
              } else if (question.answers == "") is_ok = false;
            });
          } else is_ok = false;
        });
      } else is_ok = false;
      // console.log("is ok: ", is_ok);
      return is_ok;
    },
    isFormValid() {
      return (
        this.form.information.title !== "" &&
        this.form.information.teams.length > 0 &&
        this.form.information.type_evaluation_id !== "" &&
        this.form.information.seniority_required !== "" &&
        this.form.information.illustration !== "" &&
        this.form.trainings.length > 0
      );
    },
    setupFormLevel(step) {
      this.form_step = step;
    },
    disableForm() {
      this.setupFormLevel(this.form_steps.step_information);
      this.empty_form = true;
    },
    goToNextLevel() {
      const next_level = this.form_step.slug + 1;
      Object.entries(this.form_steps).forEach(([key, value]) => {
        if (value.slug == next_level) {
          console.log(value.slug, this.form_step.slug);
          this.form_step = value;
          return true;
        }
      });
    },
    goToPreviousLevel() {
      Object.entries(this.form_steps).forEach(([key, value]) => {
        if (value.slug == this.form_step.slug - 1) {
          this.form_step = value;
          return true;
        }
      });
    },
    getLibelle(val) {
      let libelle = "";
      switch (val) {
        case "radio":
          libelle = "Choix unique";
          break;
        case "checkbox":
          libelle = "Choix multiple";
          break;
        case "text":
          libelle = "Texte";
          break;
        default:
          break;
      }
      return libelle;
    },
    async getPackTrainingInformations() {
      try {
        this.$vs.loading();
        let response = await this.$http.get(
          "trainings-pack/information/" + this.$route.params.slug
        );
        if (response.data) {
          this.$vs.loading.close();
          let data = {
            id: "",
            slug: "",
            title: "",
            type_evaluation_id: "",
            illustration: "",
            seniority_required: "",
            teams: [],
          };
          data.id = response.data.id;
          data.slug = response.data.slug;
          data.title = response.data.title;
          data.type_evaluation_id = response.data.type_evaluation_id;
          data.seniority_required = response.data.seniority_required;
          this.published = response.data.published;
          data.illustration = response.data.illustration
            ? response.data.illustration
            : null;
          let teams = JSON.parse(response.data.teams);
          teams.forEach((element) => {
            data.teams.push(element.id);
          });
          this.form.information = data;
          response.data.trainings.forEach((element, key) => {
            this.form.trainings.push({
              id: element.id,
              training_index: key,
              filter_index: "#" + (key + 1),
              slug: element.slug,
              title: element.title,
              type: {
                id: element.type_training.id,
                name: element.type_training.name,
              },
              category: {
                id: element.category_training.id,
                name: element.category_training.name,
              },
              attached_files: element.attachment_list ? element.attachment_list : [],
              attachements: [],
              content: element.content,
              illustration_file: element.illustration_file,
              illustration_name: element.illustration_name,
              video: element.media ? element.media : null,
            });
          });
          response.data.quizzs.forEach((element, key) => {
            let questions = [];

            element.questions.forEach((question, index) => {
              let answers = [];
              if (question.type == "text") {
                answers.push(question.answers);
              } else {
                question.answers.forEach((answer) => {
                  answers.push({
                    answers: answer.answers,
                    correct: answer.correct == "true" ? true : false,
                  });
                });
              }

              questions.push({
                index: "#" + (index + 1),
                id: question.id,
                slug: question.slug,
                type_question: question.type,
                type_question_libelle: this.getLibelle(question.type),
                question: question.question,
                instructions: question.instructions
                  ? question.instructions
                  : "N/A",
                answers: answers,
              });
            });
            let training_id = "";
            response.data.trainings.forEach((training, training_index) => {
              if (element.training_id == training.id) {
                training_id = training_index;
              }
            });

            this.form.quizzs.push({
              id: element.id,
              slug: element.slug,
              title: element.title,
              category_id: element.category_evaluation
                ? element.category_evaluation.id
                : null,
              category: element.category_evaluation
                ? element.category_evaluation
                : null,
              duration: element.duration,
              required_avg: element.required_avg,
              seniority_required: element.seniority_required,
              nbr_question_by_survey: element.nbr_question_by_survey,
              questions: questions,
              training_id: training_id,
              training_index: training_id,
              pack_training_id: element.pack_training_id
                ? element.pack_training_id
                : null,
            });
          });
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erreur",
          text: error.response.data
            ? error.response.data.message
            : "Une erreur s'est produite, Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
      }
    },
    callBackQuizz(action, model, index) {
      if (action == "add") {
        // this.form.quizzs.push(model);
      } else if (action == "update") {
        // console.log(model);
        // this.form.quizzs[index] = model;
      } else if (action == "delete") {
        // console.log(index);
        // this.form.quizzs.splice(index, 1);
      }
    },
    callBackTrainings(action, model, index) {
      if (action == "add") {
        // this.form.trainings.push(model);
      } else if (action == "update") {
        // this.form.trainings[index] = model;
      } else if (action == "delete") {
        // this.form.trainings.splice(index, 1);
      }
    },
    callBackInformation(model, old_type_evaluation) {
      this.form.information = model;
      if (old_type_evaluation == "une-par-formation") {
        this.form.quizzs = [this.form.quizzs[0]];
        console.log(this.form.quizzs.length);
      }
    },
    async saveTrainingPack() {
      try {
        this.$vs.loading();
        let formData = new FormData();
        formData.append("slug", this.$route.params.slug);
        formData.append("title", this.form.information.title);
        formData.append("published", this.published == "1" ? "1" : "0");
        formData.append("teams", this.form.information.teams.join(","));
        formData.append(
          "seniority_required",
          this.form.information.seniority_required
        );
        formData.append(
          "type_evaluation_id",
          this.form.information.type_evaluation_id
        );
        formData.append(
          "illustration",
          this.form.information.illustration &&
            this.form.information.illustration.id
            ? ""
            : this.form.information.illustration
        );
        this.form.trainings.forEach((training, key) => {
          formData.append(
            "trainings[" + key + "][id]",
            training.id ? training.id : ""
          );
          formData.append(
            "trainings[" + key + "][slug]",
            training.slug ? training.slug : ""
          );
          formData.append(
            "trainings[" + key + "][title]",
            training.title ? training.title : ""
          );
          formData.append(
            "trainings[" + key + "][attached_id]",
            training.attached_id ? training.attached_id : ""
          );
          formData.append("trainings[" + key + "][content]", training.content);
          formData.append(
            "trainings[" + key + "][illustration]",
            training.illustration ? training.illustration : ""
          );
          formData.append(
            "trainings[" + key + "][training_video]",
            training.training_video ? training.training_video : ""
          );
          formData.append(
            "trainings[" + key + "][type_id]",
            training.type ? training.type.id : ""
          );
          formData.append(
            "trainings[" + key + "][category_id]",
            training.category ? training.category.id : ""
          );
          training.attachements.forEach((attached, index) => {
            formData.append(
              "trainings[" + key + "][attached_files][" + index + "]",attached
            );
          });
        });

        let form_quizss = [];

        this.form.quizzs.forEach((quizz, key) => {
          formData.append("quizzs[" + key + "][id]", quizz.id ? quizz.id : "");
          formData.append(
            "quizzs[" + key + "][slug]",
            quizz.slug ? quizz.slug : ""
          );
          formData.append("quizzs[" + key + "][title]", quizz.title);
          console.log(quizz.training_index);
          formData.append(
            "quizzs[" + key + "][training_index]",
            quizz.training_index == undefined ? this.form.trainings[this.form.trainings.length - 1] : quizz.training_index
          );
          formData.append(
            "quizzs[" + key + "][required_avg]",
            quizz.required_avg
          );
          formData.append(
            "quizzs[" + key + "][nbr_question_by_survey]",
            quizz.nbr_question_by_survey
          );
          formData.append("quizzs[" + key + "][duration]", quizz.duration);
          if (quizz.category) {
            formData.append(
              "quizzs[" + key + "][category_id]",
              quizz.category.id
            );
          }
          if (quizz.category_id) {
            formData.append(
              "quizzs[" + key + "][category_id]",
              quizz.category_id
            );
          }
          quizz.questions.forEach((question, index) => {
            formData.append(
              "quizzs[" + key + "][questions][" + index + "][id]",
              question.id ? question.id : ""
            );
            formData.append(
              "quizzs[" + key + "][questions][" + index + "][slug]",
              question.slug ? question.slug : ""
            );
            formData.append(
              "quizzs[" + key + "][questions][" + index + "][question]",
              question.question
            );
            formData.append(
              "quizzs[" + key + "][questions][" + index + "][type_question]",
              question.type_question
            );
            formData.append(
              "quizzs[" + key + "][questions][" + index + "][instructions]",
              question.instructions
            );
            if (question.type_question !== "text") {
              question.answers.forEach((answer, answer_index) => {
                formData.append(
                  "quizzs[" +
                  key +
                  "][questions][" +
                  index +
                  "][answers][" +
                  answer_index +
                  "][answers]",
                  answer.answers
                );
                formData.append(
                  "quizzs[" +
                  key +
                  "][questions][" +
                  index +
                  "][answers][" +
                  answer_index +
                  "][correct]",
                  answer.correct
                );
              });
            } else
              formData.append(
                "quizzs[" + key + "][questions][" + index + "][answers]",
                question.answers
              );
          });
        });

        let response = await this.$http.post(
          "/trainings-pack/update",
          formData
        );
        if (response.data) {
          this.$vs.loading.close();
          window.getApp.success("Opération effectuée avec succès.");
          this.$router.push({ name: "formation-pack-list" });
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erreur",
          text: error.response.data
            ? error.response.data.message
            : "Une erreur s'est produite, Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
      }
    },
    publishTrainingPack() {
      this.published = "1";
      this.saveTrainingPack();
    },
  },
  mounted() {
    this.getPackTrainingInformations();
  },
};
</script>

<style lang="scss">
.flex-container {
  display: flex;
  flex-wrap: nowrap;

  .tab_menu {
    width: auto;
    margin-right: 8px;
  }

  .tab_content {
    width: 100%;
    // margin: 3px;
  }
}

.menu_items {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 6px 0px;
  grid-template-areas:
    "."
    "."
    ".";

  .menu_item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 23px;
    gap: 10px;
    width: 188px;
    height: 44px;
    border-radius: 5px;
    color: #000000;
    font-weight: bold;
    cursor: pointer;
  }

  .is_active {
    background: #000000;
    color: #ffcc00;
    border-radius: 5px;
  }
}

.vs-input-number {
  margin: 0px !important;

  button {
    color: #000000;
  }
}

.d-none {
  display: none;
}

.label {
  font-size: 14px;
  color: #000000;
  font-weight: 450;
  font-size: 16px;
  line-height: 21px;
}

.footer-row {
  position: absolute;
  bottom: 2%;
  left: -2%;
  justify-content: end;
}

.footer {
  position: relative;

  button {
    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    background: transparent !important;
    position: relative;
  }

  .black-button {
    border: 1px solid black;
    background: transparent !important;
    color: black;
  }

  .action-button {
    background: #ffcc00 !important;
  }
}

.footer button:hover {
  box-shadow: 0px 0px 0px transparent !important;
}

.con-vs-card.fixedHeight {
  min-height: 585px !important;
  position: relative;
}

.vs-card--content.fixedHeight {
  min-height: 585px !important;
}
</style>
